@if (show) {
  <div class="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 flex flex-col items-center gap-3">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      <p class="text-sm text-gray-700">{{ message }}</p>
    </div>
  </div>
}
